import "./setupAxios";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/theme.css';
import "./styles/sidebar.css";

const root = ReactDOM.createRoot(document.getElementById('root'));

// ✅ StrictMode retiré pour éviter le double rendu en dev
root.render(
  <App />
);

reportWebVitals();
